// config.js
//const API_DOMAIN = 'https://190.149.113.150:9020';
const API_DOMAIN = 'https://elarenal.mosiws.com:2087';
//                          172.105.148.169:2087
export default API_DOMAIN;
